export const emails = [
  {
    name: 'Aditya Sharma',
    email: 'adityarrk17@gmail.com',
    image: 'https://ved.test.oqlous.com/assets/google.svg',
  },
  {
    name: 'Nirmal S',
    email: 'nirmalsinqbator@gmail.com',
    image: 'https://ved.test.oqlous.com/assets/google.svg',
  },
  {
    name: 'Sarthak Choudhary',
    email: 'choudharysarthak124@gmail.com',
    image: 'https://ved.test.oqlous.com/assets/google.svg',
  },
  {
    name: 'Akshay Jangra',
    email: 'akshayjangra8888@gmail.com',
    image: 'https://ved.test.oqlous.com/assets/google.svg',
  },
];

export const jirauser = [
  {
    name: 'Aditya Sharma',
    email: 'aditya46660@gmail.com',
    id: '712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38',
  },
  {
    name: 'Akshay Kumar',
    id: '712020:1fb99c1e-0bc3-4bb5-b609-c2094726a278',
  },
  {
    name: 'Nirmal S',
    id: '712020:46a2ebcb-c201-43cd-95d3-5d115d65e042',
  },
  {
    name: 'Sarthak Choudhary',
    id: '712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba',
  },
  {
    name: 'Aryan Jha',
    id: '712020:cce7909c-93d1-466f-8635-983de5104341',
  },
  {
    name: 'Choudhary Sarthak',
    id: '712020:6208e171-2ffd-4a5a-ba6d-134d164dbc22',
  },
  {
    name: 'Ayush Vishwakarma2016',
    id: '712020:bae53cd0-990b-488a-af42-52c3ce763dce',
  },
  {
    name: 'Atlas for Jira Cloud',
    id: '630db2cd9796033b256bc349',
  },
  {
    name: 'Atlassian Assist',
    id: '5cb4ae0e4b97ab11a18e00c7',
  },
  {
    name: 'Chat Notifications',
    id: '5b70c8b80fd0ac05d389f5e9',
  },
  {
    name: 'Microsoft Teams for Confluence Cloud',
    id: '6035864ce2020c0070b5285b',
  },
  {
    name: 'Jira Outlook',
    id: '5d53f3cbc6b9320d9ea5bdc2',
  },
];

export const repo = [
  {
    Repository: 'test-environment',
    Collaborators: ['Aditya5harma (admin)'],
  },
  {
    Repository: 'claude_agent',
    Collaborators: [
      '01Akshayjangra (write)',
      'NIRMALSNAMBIAR (write)',
      'Cenult (write)',
      'Aditya5harma (write)',
      'Oqlous (admin)',
    ],
  },
  {
    Repository: 'oqlous-server',
    Collaborators: [
      '01Akshayjangra (write)',
      'Cenult (write)',
      'Aditya5harma (write)',
      'Oqlous (admin)',
    ],
  },
  {
    Repository: 'EleQtra_AI',
    Collaborators: ['Aditya5harma (admin)'],
  },
  {
    Repository: 'hackathon',
    Collaborators: [
      '01Akshayjangra (write)',
      'Aditya5harma (write)',
      'inqbatortechnologies (write)',
    ],
  },
  {
    Repository: 'inqbator_web',
    Collaborators: [
      '01Akshayjangra (write)',
      'Aditya5harma (write)',
      'inqbatortechnologies (admin)',
    ],
  },
  {
    Repository: 'inQbator-Website',
    Collaborators: [
      '01Akshayjangra (write)',
      'NIRMALSNAMBIAR (admin)',
      'Aditya5harma (write)',
    ],
  },
  { Repository: 'Task_Manager', Collaborators: ['Aditya5harma (admin)'] },
  {
    Repository: 'MyEdTech',
    Collaborators: ['Aditya5harma (admin)'],
  },
  { Repository: 'Razorpay_clone', Collaborators: ['Aditya5harma (admin)'] },
  {
    Repository: 'Our_Courses',
    Collaborators: ['Aditya5harma (admin)'],
  },
  {
    Repository: 'Tech_Blogs',
    Collaborators: ['Aditya5harma (admin)'],
  },
  {
    Repository: 'Portfolio.github.io',
    Collaborators: 'Aditya5harma (admin)',
  },
  {
    Repository: 'ZeroKatta',
    Collaborators: ['Aditya5harma (admin)'],
  },
  {
    Repository: 'Router-project',
    Collaborators: ['Aditya5harma (admin)'],
  },
  {
    Repository: 'Random-gif',
    Collaborators: 'Aditya5harma (admin)',
  },
  {
    Repository: 'Parallax',
    Collaborators: ['Aditya5harma (admin)'],
  },
  {
    Repository: 'generate_password',
    Collaborators: ['Aditya5harma (admin)'],
  },
];

export const collab = [
  'Aditya5harma',
  '01Akshayjangra',
  'NIRMALSNAMBIAR',
  'Cenult',
  'Oqlous',
  'inqbatortechnologies',
];

export const jiraProject = [
  {
    ProjectName: 'oqlous AI',
    ProjectID: '10000',
    ProjectKey: 'SCRUM',
  },
];

export const jiraBoard = [
  {
    BoardName: 'SCRUM board',
    ID: '1',
    Type: 'Simple',
    Project: 'oqlous AI (SCRUM)',
    ProjectKey: 'SCRUM',
    ProjectType: 'Software',
  },
];

export const jiraSprint = [
  {
    name: 'SPRINT week 2',
    ID: '35',
    State: 'Active',
    StartDate: '2024-11-09',
    EndDate: '2024-11-16',
    Goal: 'Complete the week 2 objective',
  },
  {
    name: 'SCRUM Sprint 1',
    ID: '1',
    State: 'Active',
    StartDate: '2024-11-02',
    EndDate: '2024-11-09',
    Goal: 'To implement the week 1 objectives.',
  },
  {
    name: 'SPRINT week 3',
    ID: '36',
    State: 'Future',
    StartDate: '2024-11-17',
    EndDate: '2024-11-24',
    Goal: 'Achieve week 3 objectives.',
  },
];

export const slackChannel = [
  {
    ChannelName: 'all-slack',
    ID: 'C07Q6SPA0T0',
    Purpose:
      'Share announcements and updates about company news, upcoming events, or teammates who deserve some kudos. 🌟',
    Members: 3,
  },
  {
    ChannelName: 'social',
    ID: 'C07QDFHJJUA',
    Purpose:
      'Other channels are for work. This one’s just for fun. Get to know your teammates and show your lighter side. 🎈',
    Members: 3,
  },
  {
    ChannelName: 'startup-project',
    ID: 'C07QG128EUU',
    Purpose:
      'This channel is for everything #startup-project. Hold meetings, share docs, and make decisions together with your team.',
    Members: 3,
  },
];

export const slackUser = [
  {
    UserName: 'Slackbot',
    ID: 'USLACKBOT',
    RealName: 'Slackbot',
    TimeZone: 'Pacific Standard Time (PST)',
  },
  {
    UserName: 'choudharysarthak124',
    ID: 'U07PYV3HC5V',
    RealName: 'choudharysarthak124',
    Email: 'choudharysarthak124@gmail.com',
    TimeZone: 'India Standard Time (IST)',
  },
  {
    UserName: 'adityarrk17',
    ID: 'U07QALM151B',
    RealName: 'adityarrk17',
    Email: 'adityarrk17@gmail.com',
    TimeZone: 'India Standard Time (IST)',
  },

  {
    UserName: 'centinel7ultimo',
    ID: 'U07QS662BC1',
    RealName: 'Oqlous Tester',
    Email: 'centinel7ultimo@gmail.com',
    TimeZone: 'India Standard Time (IST)',
    Admin: 'Yes',
    Owner: 'Yes',
  },

  {
    UserName: 'test_app',
    ID: 'U07R29W4FHN',
    RealName: 'Test App',
    TimeZone: 'Pacific Standard Time (PST)',
    Bot: 'Yes',
  },
  {
    UserName: 'oqlous_ai',
    ID: 'U080KL3N5A6',
    RealName: 'Oqlous AI',
    TimeZone: 'Pacific Standard Time (PST)',
    Bot: 'Yes',
  },
];

export const confluenceSpace = [
  {
    name: 'ADITYA SHARMA',
    key: '~7120202f9c719e9dbe4eaba83977f85ebc5b38',
  },
  {
    name: 'Nirmal S ( Founder )',
    key: '~71202046a2ebcbc20143cd95d35d115d65e042',
  },
  {
    name: 'oqlous AI',
    key: 'OA',
  },
  {
    name: 'Sarthak Choudhary',
    key: '~7120207c2d21873e7e4efd9c9bde3e41646aba',
  },
];
